import styled from 'styled-components';

import useI18n from '../../common/hooks/useI18n';
import { Empty } from 'antd';

type Props = {
  pageSize: number;
  resultsCount: number;
  className?: string;
};

const ResultsBottomSection = ({
  pageSize,
  resultsCount,
  className,
}: Props): JSX.Element => {
  const i18n = useI18n();

  return (
    <div className={className}>
      {pageSize > 0 ? (
        i18n.t('search.messages.resultsInfo', {
          pageSize,
          resultsCount,
        })
      ) : (
        <Empty description={i18n.t('search.messages.noResults')} />
      )}
    </div>
  );
};

export default styled(ResultsBottomSection)`
  font-size: 14px;
  line-height: 18px;
  text-align: center;

  @media ${(props) => props.theme.breakpoints.xs} {
    font-size: 12px;
    line-height: 16px;
  }
`;
